import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default async function customCartRemove({ client, config }: Context, parms: CustomQuery): Promise<ApiResult> {
  const { skuId } = parms;
  const url = new URL('/mall/cart/remove', config.api.url);

  // // Add parameters passed from composable as query strings to the URL
  // url.searchParams.set('password', password);
  const query: CustomQuery = {
    sku_id: skuId
  };

  // Use axios to send a GET request
  const { data } = await client.post(url.href, query);
  // Return data from the API
  return data;
}
